import { Record } from "immutable";
import Globalize from "globalize";

const defaults = {
    id: undefined,
    catalog_id: "",
    type: "item",
    label: "",
    notes: "",
    item: undefined,
    item_id: "",
    sync_id: "",
    sort: 0,
    options: {},
    __out_of_range: false,
    __out_of_range_message: "",
};

export class CatalogEntryRecord extends Record(defaults) {
    declare id: string;
    declare __out_of_range_message: string;

    unavailableProductWarning(scope) {
        let resource = "linesheet";

        if (scope.brand.hasPreference("linesheets_are_catalogs")) {
            resource = "catalog";
        }

        if (this.__out_of_range_message) {
            return Globalize.formatMessage(this.__out_of_range_message);
        } else {
            return Globalize.formatMessage(
                `This product is unavailable in this ${resource} or custom list's delivery window`
            );
        }
    }
}

export default CatalogEntryRecord;
